/*
 * fn: getComboContested
 *
 * Gets contested list of vote scores
 *
 */
import { type ComboBaseType } from '@/defs/combo'

const checkScore = (score?: number) => !!score && score >= 0.4 && score < 0.5

export const getComboContested = (combo: ComboBaseType) => ({
  isContestedEarly: checkScore(combo.vote?.earlyScore),
  isContestedPrereq: checkScore(combo.vote?.prereqScore),
  isContestedResult: checkScore(combo.vote?.resultScore),
})
